import * as ActionTypes from '../actionTypes';

export default function reducer(state = {}, action) {
    let object;
    switch (action.type) {
        case ActionTypes.COMPLETE_GET_DD_AGREEMENT:
            object = {
                ddAgreementRecord: action.payload,
            };
            return { ...state, ...object };
        case ActionTypes.FAILED_GET_DD_AGREEEMENT:
            object = {
                ddAgreementRecord: 'failed',
            };
            return { ...state, ...object };
        default:
            return state;
    }
}
